import React from 'react'
import injectSheet from 'react-jss'
import styles from './small-screen-placeholder.styles'
import classNames from 'classnames'
import cat from './cat-squashed.gif'

const SmallScreenPlaceholder = ({ classes, className }) => (
  <div className={classNames(classes.container, className)}>
    <img
      className={classes.cat}
      src={cat}
      alt="Cat trying to fit in the screen"
    />
    <div className={classes.textBox}>
      <p className={classes.title}>Too big for this screen!</p>
      <p className={classes.desc}>
        Please use a tablet or laptop <br />to plan a lesson.
      </p>
    </div>
  </div>
)

export default injectSheet(styles)(SmallScreenPlaceholder)
